import React from "react";
import { NavLink } from "react-router-dom";

export default function BusinessConsultancyServices() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Business Consultancy Services</h1>
            <h5 className="text-muted">
              Strategic Guidance to Drive Growth, Innovation, and Operational Excellence
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/business-consulting-concept-illustration_114360-1296.jpg"
              alt="Business Consultancy"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Why Choose Our Business Consultancy?</h2>
            <p>
              At <strong>Bytlas Intelligence</strong>, we offer expert consultancy services designed to help your business navigate complex challenges, identify new opportunities, and implement effective strategies for sustainable success.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Market Analysis & Competitive Intelligence</li>
              <li className="list-group-item">✅ Operational & Process Improvement</li>
              <li className="list-group-item">✅ Financial Planning & Risk Management</li>
              <li className="list-group-item">✅ Technology & Digital Transformation Roadmaps</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Our Consultancy Approach</h3>
            <p>
              We work closely with your leadership to understand your business goals, challenges, and culture. Our tailored recommendations are actionable, measurable, and aligned with your vision.
            </p>
            <p>
              Whether you need help scaling operations, entering new markets, or optimizing resources, we bring deep industry knowledge and practical solutions.
            </p>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">Services We Offer</h3>
            <ul>
              <li>📊 Business Strategy & Planning</li>
              <li>🔍 Market Research & Feasibility Studies</li>
              <li>⚙️ Process & Performance Optimization</li>
              <li>💼 Change Management & Leadership Coaching</li>
              <li>💻 IT & Digital Strategy Consulting</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Get Your Free Business Consultation
          </NavLink>
        </div>
      </div>
    </section>
  );
}
